<nz-layout>
  <app-global-primary-header
    style="height: 48px; min-width: 1280px"
    *ngIf="showPrimaryHeader"
  ></app-global-primary-header>
  <app-global-secondary-header
    *ngIf="showSecondaryHeader"
    [ngClass]="{
      'custom-zindex': customZindex.includes(pageName)
    }"
  ></app-global-secondary-header>
  <nz-layout
    [style.height]="contentSectionHeight"
    class="contentSection"
    [ngClass]="{
      'content-and-sider': !isOpenInExcelAddin,
      'large-secondary-header-content': fBarPages.includes(pageName),
      'no-secondary-header-content': noSecHeader.includes(pageName)
    }"
  >
    <nz-sider
      [ngStyle]="{ display: showLeftSidebar ? 'block' : 'none' }"
      [ngClass]="
        !disabledSidebar
          ? this.pageName === 'watchlist'
            ? 'leftSider watchlistSider'
            : this.pageName === 'industry_metrics'
              ? 'leftSider industry-metrics-left-sider'
              : this.pageName === 'comparative-analysis'
                ? 'leftSider comparative-analysis'
                : showReturnToHomeLink.includes(this.pageName)
                  ? 'leftSider returnToHome'
                  : 'leftSider'
          : 'leftSider disabled'
      "
      nzTheme="light"
      nzCollapsible
      [(nzCollapsed)]="isCollapsed"
      [nzCollapsedWidth]="0"
      [nzZeroTrigger]="siderArrowTemplate"
      (nzCollapsedChange)="leftSiderChanged($event)"
    >
      <app-left-panel
        [leftPanelCollapsed]="leftPanelCollapsed"
      ></app-left-panel>
    </nz-sider>
    <nz-content
      class="content-section"
      [ngClass]="
        showPrimaryHeader ||
        showSecondaryHeader ||
        showLeftSidebar ||
        showFooter
          ? ''
          : 'nz-content'
      "
      [ngClass]="{
        'large-secondary-header-content': fBarPages.includes(pageName),
        'no-secondary-header-content': noSecHeader.includes(pageName)
      }"
    >
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
  <nz-footer *ngIf="showFooter">
    <app-global-footer></app-global-footer>
  </nz-footer>
</nz-layout>
<ng-template #siderArrowTemplate>
  <va-icon
    *ngIf="isCollapsed"
    size="medium"
    name="arrow-circle-right"
    class="sider-icon"
  ></va-icon>
  <va-icon
    *ngIf="!isCollapsed"
    size="medium"
    name="arrow-circle-left"
    class="sider-icon"
  ></va-icon>
</ng-template>

<app-global-user-settings
  [(isVisibleEteModal)]="isVisibleEteModal"
  [showExcelAdvanceOptions]="false"
  (close)="onCloseEteModal()"
></app-global-user-settings>
